import './DatePickers.scss';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import ReactDatePicker from 'react-datepicker';

interface IDateRangePickerProps {
  maxDate?: Date;
  minDate?: Date;
  selectedEndDate: Date;
  selectedStartDate: Date;
  onSetDates: (startDate: Date, endDate: Date) => Promise<void>;
}

export const DateRangePicker = observer((props: IDateRangePickerProps): ReactElement => {
  const { selectedStartDate, selectedEndDate, onSetDates, minDate, maxDate } = props;

  const [isOpen, setIsOpen] = useState(false);

  const [startDate, setStartDate] = useState(selectedStartDate);
  const [endDate, setEndDate] = useState<Date | null>(selectedEndDate);

  const toggle = (): void => {
    setIsOpen((prevState) => !prevState);
  };

  const onChange = async (dates: [Date | null, Date | null]): Promise<void> => {
    if (!dates[0]) {
      return;
    }

    setStartDate(dates[0]);
    setEndDate(dates[1]);

    if (!dates[1]) {
      return;
    }

    toggle();
    await onSetDates(dates[0], dates[1]);
  };

  const renderLabel = (): ReactElement => (
    <div
      className='date-label-container'
      onClick={toggle}
    >
      <div>
        <label
          className='selected-date'
          onClick={toggle}
        >{`${selectedStartDate.toLocaleDateString()} - ${selectedEndDate.toLocaleDateString()}`}</label>
      </div>
      <FontAwesomeIcon
        icon={isOpen ? faAngleUp : faAngleDown}
        onClick={toggle}
      />
    </div>
  );

  return (
    <div className='date-range-field'>
      <ReactDatePicker
        minDate={minDate}
        maxDate={maxDate}
        startDate={startDate}
        endDate={endDate ?? undefined}
        onChange={(dates) => {
          void onChange(dates);
        }}
        open={isOpen}
        customInput={renderLabel()}
        onBlur={toggle}
        onClickOutside={toggle}
        selectsRange
        calendarStartDay={1}
        disabledKeyboardNavigation
      />
    </div>
  );
});
